import jwtDecode from 'jwt-decode';

export const saveToken = (token) => localStorage.setItem('admin_token', token);
export const clearToken = () => localStorage.removeItem('admin_token');
export const getToken = () => localStorage.getItem('admin_token');
export const isLoggedIn = () => !!getToken();
export const getAdminFromToken = () => {
  const t = getToken();
  if (!t) return null;
  try { return jwtDecode(t); } catch (e) { return null; }
};
